import { useContext } from 'react';

import { FlowContext } from '~/context';

export const useFlow = () => useContext(FlowContext);
